import { render } from "./ExclusionView.vue?vue&type=template&id=25d458b2&scoped=true"
import script from "./ExclusionView.vue?vue&type=script&lang=js"
export * from "./ExclusionView.vue?vue&type=script&lang=js"

import "./ExclusionView.vue?vue&type=style&index=0&id=25d458b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d458b2"]])

export default __exports__